import axios from 'axios';

import configs from '../helpers/config'

async function getAuthorization() {
    try {
        const token = await localStorage.getItem('token');
        if (token) {
            return { 'Authorization': `Bearer ${token}` };
        }
    } catch (err) {
        console.log(err);
    }
    return {};
}

async function getHeadersAsync() {
    return { headers: await getAuthorization(), crossDomain: true };
}

async function postAsync(url, data) {
    return await axios.post(`${configs.SERVER_URL}/${url}`, data, await getHeadersAsync());
}

async function getAsync(url) {
    return await axios.get(`${configs.SERVER_URL}/${url}`, await getHeadersAsync());
}

/*
https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/
*/
function showFile(blob, options) {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([blob], { type: options.mime })

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob, options.title);
        return;
    }

    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const url = window.webkitURL || window.URL;
    const data = url.createObjectURL(newBlob);
    var link = document.createElement('a');
    link.href = data;
    link.download = options.title;
    link.click();
}

async function downloadAsync(url, options) {
    var headers = {
        ...await getHeadersAsync(),
        responseType: 'arraybuffer'
    };

    return axios.post(`${configs.SERVER_URL}/${url}`, {}, headers)
        .then(r => showFile(r.data, options));
}

export default { postAsync, getAsync, downloadAsync }